import React from 'react';
import { LegalNotice } from 'components/legal-notice';

export const LegalNoticePage: React.FC = () => <LegalNotice />;
